import React, { useEffect, useState } from "react";
import { waLink } from "../lib/site";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-[var(--line)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14 flex items-center justify-between py-5">
        <a href="#top" className="serif italic text-[17px] tracking-wider-elegant text-[#111]">
          Rapallini
        </a>

        <nav className="hidden md:flex items-center gap-10 text-[12px] sans tracking-luxe text-[#111]">
          <a href="#looks" className="underline-hover" data-testid="nav-looks">The Six</a>
          <a href="#prints" className="underline-hover" data-testid="nav-prints">Prints</a>
          <a href="#about" className="underline-hover" data-testid="nav-about">House</a>
          <a href="#care" className="underline-hover" data-testid="nav-care">Care</a>
          <a href="#contact" className="underline-hover" data-testid="nav-contact">Contact</a>
        </nav>

        <a
          data-testid="nav-whatsapp"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:inline-block text-[11px] sans tracking-luxe border border-[#111] px-4 py-2.5 rounded-full hover:bg-[#111] hover:text-white transition-colors duration-500"
        >
          WhatsApp
        </a>
      </div>
    </header>
  );
}
